import { render } from "./ForgotPasswordScreen.vue?vue&type=template&id=5dae8d86&scoped=true"
import script from "./ForgotPasswordScreen.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordScreen.vue?vue&type=script&lang=js"

import "./ForgotPasswordScreen.vue?vue&type=style&index=0&id=5dae8d86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dae8d86"]])

export default __exports__